/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Review4_QuoteInputs */

const es_landing_review4_quote = /** @type {(inputs: Landing_Review4_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venimos de Madrid para ver las luces de Vigo y ha sido una experiencia muy buena. Hay que llevar abrigo.`)
};

const gl_landing_review4_quote = /** @type {(inputs: Landing_Review4_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimos de Madrid para ver as luces de Vigo e foi unha experiencia moi boa. Hai que levar abrigo.`)
};

const en_landing_review4_quote = /** @type {(inputs: Landing_Review4_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We came from Madrid for the Vigo Christmas lights and it was a great experience. Bring warm clothes.`)
};

/**
* | output |
* | --- |
* | "We came from Madrid for the Vigo Christmas lights and it was a great experience. Bring warm clothes." |
*
* @param {Landing_Review4_QuoteInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_review4_quote = /** @type {((inputs?: Landing_Review4_QuoteInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Review4_QuoteInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_review4_quote(inputs)
	if (locale === "en") return en_landing_review4_quote(inputs)
	return es_landing_review4_quote(inputs)
});